/**
 * 公共导航工具函数（优化微信环境兼容性）
 * @param {number} lat - 目的地纬度
 * @param {number} lng - 目的地经度
 * @param {string} name - 目的地名称
 * @param {string} address - 地址
 * @param {object} wx - 从组件传递的wx对象（模块内引入的版本）
 * @param {boolean} configured - wx配置状态
 */
export const navigateToLocation = (lat, lng, name, address = '', wx, configured) => {
  // 检查是否在微信内置浏览器
  const isWechat = /MicroMessenger/i.test(navigator.userAgent);

  if (isWechat) {
    // 检查wx对象是否有效
    if (!wx) {
      alert('微信功能加载失败，请刷新页面重试');
      return;
    }

    // 微信环境：确保wx对象已加载且配置完成
    const checkWxReady = () => {
      // 情况1：已配置完成
      if (configured) {
        return true;
      }

      // 情况2：未配置完成，重试3次
      let retryCount = 0;
      const retryTimer = setInterval(() => {
        // 每次重试时重新获取最新的configured状态（从组件传递的实时值）
        if (configured) {
          clearInterval(retryTimer);
          openWechatMap(wx);
        } else if (retryCount >= 3) {
          clearInterval(retryTimer);
          alert('微信环境初始化超时，请稍后再试');
        }
        retryCount++;
      }, 500);
      return false;
    };

    // 打开微信内置地图
    const openWechatMap = (wx) => {
      wx.openLocation({
        latitude: lat,        // 纬度（浮点数）
        longitude: lng,       // 经度（浮点数）
        name: name,           // 位置名称
        address: address,     // 详细地址
        scale: 14,            // 地图缩放级别（1-28）
        infoUrl: '',          // 位置相关的超链接
        fail: (err) => {      // 捕获调用失败错误
          console.error('微信地图调用失败', err);
          // 常见错误：未配置JS安全域名
          if (err.errMsg.includes('permission denied')) {
            alert('该功能需在公众号安全域名下使用');
          } else {
            alert('导航功能暂时不可用，请稍后尝试');
          }
        }
      });
    };

    // 执行检查并打开地图
    if (checkWxReady()) {
      openWechatMap(wx);
    }

  } else {
    // 非微信环境：尝试打开主流地图应用（逻辑不变，增强错误处理）
    const encodedName = encodeURIComponent(name);
    const encodedAddr = encodeURIComponent(address);

    // 地图应用协议（按优先级排序）
    const mapProtocols = [
      `amapuri://route/plan/?dlat=${lat}&dlon=${lng}&dname=${encodedName}&t=0`, // 高德
      `baidumap://map/direction?destination=name:${encodedName}|latlng:${lat},${lng}&mode=driving`, // 百度
      `qqmap://map/routeplan?type=drive&to=${encodedName}&tocoord=${lat},${lng}` // 腾讯
    ];

    // 网页版地图链接（备选）
    const webMapUrls = [
      `https://uri.amap.com/navigation?to=${encodedName}&lat=${lat}&lon=${lng}&type=0`, // 高德网页版
      `https://map.baidu.com/search/${encodedAddr}/${lat},${lng}` // 百度网页版
    ];

    // 尝试打开地图应用，失败则跳转网页版
    const tryOpenMaps = (index) => {
      if (index >= mapProtocols.length) {
        // 所有地图应用都无法打开，跳转网页版
        window.location.href = webMapUrls[0];
        return;
      }

      // 尝试打开第index个地图应用
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = mapProtocols[index];
      document.body.appendChild(iframe);

      // 300ms后检测是否打开成功
      setTimeout(() => {
        document.body.removeChild(iframe);
        // 若300ms内未切换到地图应用，则尝试下一个
        tryOpenMaps(index + 1);
      }, 300);
    };

    // 开始尝试打开地图
    tryOpenMaps(0);
  }
};